type TimeRange = {from: string; to: string};

export const WEEKDAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

export type Weekday = (typeof WEEKDAYS)[number];
export type OpeningHours = Partial<Record<Weekday, TimeRange[]>>;

const time = (value: string) => value.slice(0, 5);

// Prototype v11: "Mon–Fri 08:00–17:00". Consecutive days with the same hours share one group.
export function openingHoursSummary(
  hours: OpeningHours | null | undefined,
  dayLabel: (day: Weekday) => string
): string | null {
  const groups: {first: Weekday; last: Weekday; ranges: string}[] = [];
  WEEKDAYS.forEach((day) => {
    const ranges = (hours?.[day] ?? [])
      .map((range) => `${time(range.from)}–${time(range.to)}`)
      .join(', ');
    const previous = groups.at(-1);
    const isNextDay = previous && WEEKDAYS.indexOf(previous.last) === WEEKDAYS.indexOf(day) - 1;
    if (previous && isNextDay && previous.ranges === ranges) {
      previous.last = day;
    } else {
      groups.push({first: day, last: day, ranges});
    }
  });
  const open = groups.filter(({ranges}) => ranges !== '');
  if (open.length === 0) {
    return null;
  }
  return open
    .map(({first, last, ranges}) =>
      first === last
        ? `${dayLabel(first)} ${ranges}`
        : `${dayLabel(first)}–${dayLabel(last)} ${ranges}`
    )
    .join(', ');
}
